import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "@/router";

Vue.use(Vuex);

const LANDING_API = process.env.VUE_APP_LANDING_API;

export default new Vuex.Store({
	state: {
		code: null,
		page: null,
		statId: null,
		expired: false,
		started: true,
	},
	mutations: {
		SET_CODE(state, code) {
			state.code = code;
		},
		SET_PAGE(state, page) {
			state.page = page;
		},
		SET_STAT(state, statId) {
			state.statId = statId;
		},
		SET_EXPIRED(state) {
			state.expired = true;
		},
		SET_NOT_STARTED(state) {
			state.started = false;
		}
	},
	actions: {
		load({ commit }, code) {
			// Used to prevent API response disk caching
			const timestamp = new Date().getTime();

			commit("SET_CODE", code);

			let params = window.location.search;
			params += (params === "" ? "?" : "&") + "timestamp=" + timestamp;

			return new Promise((resolve, reject) => {
				axios
					.get(LANDING_API + "/by-code/" + code + params)
					.then((resp) => {
						commit("SET_PAGE", resp.data.page);
						commit("SET_STAT", resp.data.stat_id);

						resolve();
					})
					.catch((error) => {
						// Network error (uncaught by uptimemonitor)
						if (error.response === undefined) {
							notifySlack(code, navigator.userAgent);
						}

						if (error.response.status === 412) {
							router.push({ name: "NotAvailable" });
						} else if (error.response.status === 404) {
							router.push({ name: "NotFound" });
						}

						reject(error);
					});
			});
		},
		submit({ getters }, data) {
			return new Promise((resolve, reject) => {
				data.stat_id = getters.statId;

				let fd = jsonToFormData(data);

				axios
					.post(LANDING_API + "/" + getters.pageId + "/submit", fd)
					.then((resp) => {
						resolve(resp.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		verify(context, token) {
			return new Promise((resolve, reject) => {
				axios
					.get(LANDING_API + "/verify/" + token)
					.then((resp) => {
						if (resp.data.status == "valid") {
							resolve();
						} else {
							reject();
						}
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
	},
	getters: {
		code: (state) => {
			return state.code;
		},
		statId: (state) => {
			return state.statId;
		},
		pageId: (state) => {
			return state.page.id;
		},
		root: (state) => {
			return state.page.modules[0];
		},
		content: (state) => {
			return state.page.modules.slice(1, state.page.modules.length);
		},
		settings: (state) => {
			return state.page.settings;
		},
		expired: (state) => {
			return state.expired;
		},
		started: (state) => {
			return state.started;
		}
	},
});

function buildFormData(formData, data, parentKey) {
	if (data && typeof data === "object" && !(data instanceof Date) && !(data instanceof File)) {
		Object.keys(data).forEach((key) => {
			buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
		});
	} else {
		const value = data == null ? "" : data;

		formData.append(parentKey, value);
	}
}

function jsonToFormData(data) {
	const formData = new FormData();

	buildFormData(formData, data);

	return formData;
}

function notifySlack(code, userAgent) {
	// Do not send notification if Googlebot
	if (userAgent.includes("Googlebot") || userAgent.includes("Applebot")) return;

	var body = new FormData();
	body.append('msg', `DNS issues with landing page API (${userAgent})`);
	body.append('color', "danger");
	body.append('premsg', `Landing page DNS error (${code})`);
	body.append('from', "cpn");

	axios.post('https://plugin.tools/slack/', body);
}
